import { uploadFile } from '../../services/FileUploadService'
import { isError } from '../../utils/api'

export default {
  state: {
    image: null,
    imageLoading: false,
    imageError: null,
    file: null,
    fileLoading: false,
    fileError: null
  },

  mutations: {
    setData(state, { resource, data }) {
      state[resource] = data
    },
    setLoading(state, { resource, status }) {
      state[`${resource}Loading`] = status
    },
    setError(state, { resource, error }) {
      state[`${resource}Error`] = error
    },
    reset(state, { resource }) {
      state[resource] = null
      state[`${resource}Loading`] = null
      state[`${resource}Error`] = false
    }
  },
  actions: {
    async uploadImage({ commit }, params) {
      commit('setLoading', { resource: 'image', status: true })
      commit('show', { element: 'fullPageLoader' })
      const response = await uploadFile(params).catch(e => e.response)
      if (!isError(response.status)) {
        commit('setData', { resource: 'image', data: response.data })
      }
      commit('setLoading', { resource: 'image', status: false })
      commit('hide', { element: 'fullPageLoader' })
      return response && response.data
    },
    resetImage({ commit }) {
      commit('reset', { resource: 'image' })
    }
  }
}
